/**
 * Using the `Promise.resolve()` check to see if the given `object` is a promise.
 *
 * @param {Object} object - The object that is to be checked to see if it a promise
 * @returns {boolean} - True if the object is a promise, false otherwise
 */
export default function isPromise(object) {
    // According to the spec, Promise.resolve must return the same object passed in IFF it is a promise
    return Promise.resolve(object) === object;
}
